import { isDefined } from '../../config/helpers';
import useWindowSize from '../../_hooks/useWindowSize'

const CategoryLongDescription = ({isMobile, long_desc, layout}) => {
    const screensize = useWindowSize();
    return (
        <div
            className={"p-2 mt-2 " + ((layout == 'box' && screensize.width > 1200 ) || (!isDefined(screensize.width) && !isMobile) ? 'f-size_3' : 'f-size_1')}
            dangerouslySetInnerHTML={{
                __html: long_desc,
            }}
        />
    )
}

export default CategoryLongDescription